<template>
  <AppHeader />

  <!-- Responsive parent layout -->
  <div
    class="pt-header86 flex flex-col min-lg:flex-row w-full h-screen bg-surface text-primary overflow-hidden"
  >
    <!-- Filters Section (Top on mobile, Left on desktop) -->
    <aside
      class="w-full min-lg:w-1/5 border-b min-lg:border-b-0 min-lg:border-r border-grey-light p-4 overflow-y-auto max-h-[40vh] min-lg:max-h-none"
    >
      <FiltersPanel @location-found="handleLocation" />
    </aside>

    <!-- Map Section (Middle on desktop) -->
    <main
      class="w-full min-lg:w-1/2 min-h-[300px] h-[40vh] min-lg:h-full relative p-4"
    >
      <MapView :coordinates="coords" :popupText="popup" />
    </main>

    <!-- Results Section (Bottom on mobile, Right on desktop) -->
    <section
      class="w-full min-lg:w-[30%] border-t min-lg:border-t-0 min-lg:border-l border-grey-light p-4 overflow-y-auto max-h-[40vh] min-lg:max-h-none"
    >
      <ResultsPanel />
    </section>
  </div>
</template>

<script setup>
import { ref } from "vue";
import AppHeader from "@/components/common/Header.vue";
import FiltersPanel from "./FiltersPanel.vue";
import MapView from "./MapView.vue";
import ResultsPanel from "./ResultsPanel.vue";

const coords = ref([40.22, -3.7038]);
const popup = ref("");

// Update coordinates and popup based on FiltersPanel event
const handleLocation = ({ coordinates, popupText }) => {
  coords.value = coordinates;
  popup.value = popupText;
};
</script>

<style scoped></style>
